import api from "./api";

export const loginUser = async (email, password) => {
  try {
    const response = await api.post("auth/adminLogin", { email, password });
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const allUsers = async () => {
  try {
    const response = await api.get("user/getAllUsers");
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const allUsersByContinent = async (id) => {
  try {
    const response = await api.get("user/getAllUsers?continentId=" + id);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const blockUser = async (userId) => {
  try {
    const response = await api.post("user/blockUser", userId);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const unBlockUser = async (userId) => {
  try {
    const response = await api.post("user/unblockUser", userId);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const deleteUser = async (userId) => {
  try {
    const response = await api.post("user/deleteAccount", userId);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const getAllContinents = async () => {
  try {
    const response = await api.get("continent/getAllContinent");
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
// done
export const insertActivity = async (formData) => {
  try {
    const response = await api.post("activity/insertActivity", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const editActivity = async (formData) => {
  try {
    const response = await api.post("activity/updateActivity", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
}
//done
export const getAllIndexes = async () => {
  try {
    const response = await api.get("activity/getAllActivity");
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const enableActivity = async (data) => {
  try {
    const response = await api.post("activity/enableActivity", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const editActivityName = async (data) => {
  try {
    const response = await api.post("activity/editActivityName", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done 
export const updateIndexOrder = async (data) => {
  try {
    const response = await api.post("activity/updateActivityOrder", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

//done 
export const deleteActivity = async (activityId) => {
  console.log('activityId: ', activityId);
  try {
    const response = await api.post("activity/deleteActivity", activityId);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const getAllVideos = async () => {
  try {
    // const response = await api.get("media/getAllVideos?isPromotion=false");
    const response = await api.get("media/getAllMedia")
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const getAllVideosDash = async () => {
  try {
    const response = await api.get("media/getAllMedia");
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const getAllPromotionalVideos = async () => {
  try {
    const response = await api.get("media/getAllVideos?isPromotion=true");
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const approveVideo = async (data) => {
  try {
    const response = await api.post("media/approveVideo", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const getUserStats = async () => {
  try {
    const response = await api.get("user/getUserStatistics");
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const getReportList = async () => {
  try {
    const response = await api.get("media/getReportList");
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const sendNotifications = async (data) => {
  try {
    const response = await api.post("user/sendNotificationToAll", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const rejectVideo = async (data) => {
  try {
    const response = await api.post("media/rejectVideo", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const reportStatus = async (data) => {
  try {
    const response = await api.post("media/updateReportStatus", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const setUploadAccess = async (data) => {
  try {
    const response = await api.post("user/setUserUploadAccess", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const setUploadBulkAccess = async (data) => {
  try {
    const response = await api.post("user/bulkSetUploadAccess", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const getAllCountries = async (data) => {
  try {
    const response = await api.get("countries/getAllCountry?continent=" + data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const getAllSubscriptions = async () => {
  try {
    const response = await api.get("purchase/getAllPlanUsers");
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const addInfoLink = async (data) => {
  try {
    const response = await api.post("countries/addinfoLink", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
